export const servers = {
  '/': {
    name: 'Allgemein',
    textChannels: ['willkommen', 'ankündigungen', 'allgemeiner-chat', 'feedback'],
    voiceChannels: ['Treffpunkt', 'Musik-Lounge']
  },
  '/artist-hub': {
    name: 'Künstler-Hub',
    textChannels: ['vorstellungen', 'sänger-chat', 'text-werkstatt', 'performance-tipps'],
    voiceChannels: ['Gesangs-Jam', 'Übungsraum', 'Aufnahmekabine']
  },
  '/producer-hub': {
    name: 'Produzenten-Hub',
    textChannels: ['beat-sharing', 'produktions-hilfe', 'equipment-talk', 'sample-börse'],
    voiceChannels: ['Beat-Review', 'Collab-Studio', 'Mix-Workshop']
  },
  '/profile': {
    name: 'Mein Profil',
    textChannels: ['feed', 'tracks', 'collaborations', 'messages', 'recordings', 'shared', 'saved', 'settings'],
    voiceChannels: []
  }
};